import React from 'react';
import { Quote } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const QuoteSection = ({ config = {} }) => {
  const [ref, isVisible] = useScrollAnimation();
  
  const quoteText = config.quoteText || 'Fundada por un visionario que conoce la industria, JG Models representa apoyo genuino, crecimiento inteligente y éxito sostenible.';
  const quoteAuthor = config.quoteAuthor || 'Jhosep J.';
  const quoteRole = config.quoteRole || 'Fundador, JG Models Agency';

  return (
    <section ref={ref} className="py-24 bg-[#1d1e20] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#c8784e] rounded-full filter blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#c8784e] rounded-full filter blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-4xl mx-auto text-center fade-in ${isVisible ? 'visible' : ''}`}>
          <Quote size={48} className="text-[#c8784e] mx-auto mb-8 opacity-50" />
          
          <h2 className="text-3xl md:text-4xl font-light mb-8 leading-relaxed italic text-gray-200">
            {quoteText}
          </h2>
          
          <div className="flex flex-col items-center gap-4">
            <p className="text-xl font-semibold text-[#c8784e]">{quoteAuthor}</p>
            <p className="text-gray-400 font-light">{quoteRole}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;